// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host {
      display: inline-block;
    }
    img {
      object-fit: contain;
    }
  `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/elements/zikata-logo/zikata-logo.component.ts"],"names":[],"mappings":";IACI;MACE,qBAAqB;IACvB;IACA;MACE,mBAAmB;IACrB","sourcesContent":["\n    :host {\n      display: inline-block;\n    }\n    img {\n      object-fit: contain;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
